var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10397 2.14105C7.47092 1.39832 8.53005 1.39827 8.89694 2.14105L10.1909 4.76312C10.3365 5.05817 10.6182 5.26357 10.9438 5.31097L13.8383 5.73089C14.6583 5.85034 14.9855 6.85851 14.3921 7.43695L12.2983 9.47796C12.0627 9.70767 11.9546 10.0384 12.0102 10.3627L12.5053 13.2446C12.6454 14.0614 11.7877 14.6846 11.0542 14.2993L8.4653 12.9379C8.17406 12.785 7.82583 12.7848 7.53464 12.9379L4.94675 14.2993C4.21314 14.6848 3.35546 14.0614 3.49557 13.2446L3.98971 10.3627C4.04534 10.0384 3.93812 9.70769 3.70261 9.47796L1.60885 7.43695C1.01535 6.85846 1.34245 5.85019 2.16257 5.73089L5.05612 5.31097C5.38183 5.26365 5.66338 5.05826 5.80905 4.76312L7.10397 2.14105Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/Star2.79b326f4ae80c103fa57ab62c90a02ff.svg";
export { ForwardRef as ReactComponent };